import 'client/javascript/main';
import { onContentLoaded } from 'client/javascript/on_content_loaded';
import { onPolyfillsLoaded } from 'client/javascript/util/polyfills';

import { textExpander } from 'client/javascript/text_expander';

onContentLoaded(() => {
  onPolyfillsLoaded(async () => {
    textExpander();
  });
});
